import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ProgramWiseModuleSettings from "Administrator/routes/SchoolSettings/routes/ModuleSettings/routes/ProgramWiseModuleSettings";

export default store => ({
  path: "module-settings",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "settings" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [ProgramWiseModuleSettings(store)],
});
